import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./pages/Login";
import Layout from "./layout/Layout";
import Dashboard from "./pages/Dashboard";
import Students from "./pages/Students";
import Employees from "./pages/Employees";
import HomePage from "./landing/Homepage";
import Users from "./pages/Users";
import Attendance from "./pages/Attendance";
import ForgotPassword from "./pages/ForgotPassword";
import PrivateRoute from "./routes/PrivateRoute";
import About from "./landing/About";
import Contact from "./landing/Contact";
import LandingLayout from "./landing/LandingLayout";
import Locations from "./landing/Locations";
import Academics from "./landing/Academics";
import VerifyOtp from "./pages/VerifyOtp";
import ResetPassword from "./pages/ResetPassword";
import AttendanceLog from "./pages/AttendanceLog";
import OrgMenu from "./pages/OrgMenu";
import Unauthorized from "./pages/Unauthorized";
import RoleRedirect from "./pages/RoleRedirect";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Class from "./pages/Class";
import StudentAcademic from "./pages/StudentAcademic";
import CatalogScreen from "./components/Catalogs";
import Admissions from "./pages/Admissions";
import TeacherMapping from "./pages/TeacherMapping";
import StudentFees from "./pages/StudentFeeDetails";

function App() {
  return (
    <BrowserRouter>
      <Routes>
       <Route path="/" element={<RoleRedirect />} />

        {/* Landing Pages */}
        <Route path="/" element={<LandingLayout />}>
          <Route index element={<HomePage />} />
          <Route path="about" element={<About />} />
          <Route path="academics" element={<Academics />} />
          <Route path="contact" element={<Contact />} />
          <Route path="admission" element={<Contact />} />
          <Route path="locations" element={<Locations />} />
        </Route>


        {/* Auth Pages */}
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/verify-otp" element={<VerifyOtp />} />
        <Route path="/reset-password" element={<ResetPassword />} />

         {/* Protected Routes */}
        <Route path="/dashboard"  element={
            <PrivateRoute allowedRoles={["ADMIN"]}> 
              <Layout />
            </PrivateRoute>
          }  >

          {/* Default page */}
          <Route index element={<Dashboard />} />

          <Route path="students" element={<Students />} />
          <Route path="staff" element={<Employees />} />
          <Route path="users" element={<Users />} />
          <Route path="markattendance" element={<Attendance />} />
          <Route path="myTime" element={<AttendanceLog />} />
          <Route path="studentAcademics" element={<StudentAcademic />} />
          <Route path="class" element={<Class />} />
          <Route path="organisation" element={< OrgMenu/>} />
          <Route path="catalogs" element={<CatalogScreen />} />
          <Route path="admissions" element={<Admissions />} />
          <Route path="facultyMap" element={<TeacherMapping />} />
          <Route path="fees" element={<StudentFees />} />
          <Route path="homeWork" element={<StudentFees />} />

        </Route>
        <Route path="/teacher"  element={
            <PrivateRoute allowedRoles={["TEACHER"]}> 
              <Layout />
            </PrivateRoute>
          }  >

          {/* Default page */}
          <Route index element={<Dashboard />} />
          <Route path="markattendance" element={<Attendance />} />
          <Route path="myTime" element={<AttendanceLog />} />
          {/* <Route path="academicYear" element={<AcademicYear />} /> */}

        </Route>

        <Route path="/unauthorized" element={<Unauthorized />} />
      </Routes>
      <ToastContainer position="top-center" autoClose={3000} />
    </BrowserRouter>
  );
}

export default App;